import Valkyrie, { viCheck } from "@sippy-platform/valkyrie";

import { IconButton, Stack } from "@mui/material";
import { amber, grey, lightGreen, lime, orange, yellow } from "@mui/material/colors";
import PropTypes from "prop-types";

function ColorPicker(props) {
  return (
    <Stack
      direction="row"
      sx={[
        {
          flexWrap: "wrap",
          gap: 0.75,
          justifyContent: "center",
        },
        {
          textAlign: "center",
          p: 1.5,
          borderRadius: 1,
        },
        props.disabled && {
          backgroundColor: "rgba(150,150,150,.1)",
        },
      ]}
    >
      {props.colors.map((color, key) => (
        <IconButton
          key={key}
          disabled={props.disabled}
          sx={{
            borderRadius: 40,
            cursor: props.disabled ? "auto" : "pointer",
            filter: props.disabled ? "grayscale(80%)" : "",
            color:
              [lime[500], yellow[500], amber[500], orange[500], lightGreen[500], grey[500]].indexOf(color[500]) >= 0
                ? "#000"
                : "#fff",
            background: `linear-gradient(135deg, ${color[300]} 0%, ${color[400]} 100%)`,
            ":hover": {
              background: `linear-gradient(135deg, ${color[400]} 0%, ${color[500]} 100%)`,
            },
          }}
          color={color[500]}
          onClick={props.disabled ? undefined : () => props.select(color[500])}
          id={`color-${key}`}
          icon={props.value === color[500] ? viCheck : undefined}
          px={36}
        >
          {props.value === color[500] ? (
            <Valkyrie icon={viCheck} />
          ) : (
            <Valkyrie icon={viCheck} style={{ visibility: "hidden" }} />
          )}
        </IconButton>
      ))}
    </Stack>
  );
}

ColorPicker.propTypes = {
  colors: PropTypes.array,
  select: PropTypes.func,
  value: PropTypes.string,
  disabled: PropTypes.bool,
};

export default ColorPicker;
